export default "__VITE_ASSET__vNebVHei__"